import { FiltroConsultaReciboResumen } from "../../config_general_recibo/modelo/NovedadesRecibidas";
import { ResumenNovedad } from "../modelo/ConsultaNovedadesResumen";

export const CONSULTAR_NOVEDADES_RESUMEN = "CONSULTAR_NOVEDADES_RESUMEN";
export const CONSULTAR_NOVEDADES_RESUMEN_XLS = "CONSULTAR_NOVEDADES_RESUMEN_XLS";
export const EXITO_CONSULTA_NOVEDADES_RESUMEN = "EXITO_CONSULTA_NOVEDADES_RESUMEN";
export const EXITO_CONSULTA_NOVEDADES_RESUMEN_XLS = "EXITO_CONSULTA_NOVEDADES_RESUMEN_XLS";
export const ERROR_CONSULTA_NOVEDADES_RESUMEN = "ERROR_CONSULTA_NOVEDADES_RESUMEN";
export const ERROR_CONSULTA_NOVEDADES_RESUMEN_XLS = "ERROR_CONSULTA_NOVEDADES_RESUMEN_XLS";
export const LIMPIAR_MENSAJES_ESTADO = "LIMPIAR_MENSAJES_ESTADO";

export const consultarNovedadesResumen = (filtro: FiltroConsultaReciboResumen) => ({ type: CONSULTAR_NOVEDADES_RESUMEN, filtro });
export const exitoConsultaNovedadesResumen = (datosEntidad: Array<ResumenNovedad>, paginas: number, totalDatos: number) => ({
    type: EXITO_CONSULTA_NOVEDADES_RESUMEN, datosEntidad, paginas, totalDatos
});
export const errorConsultaNovedadesResumen = () => ({ type: ERROR_CONSULTA_NOVEDADES_RESUMEN });

export const consultarNovedadesResumenXLS = (filtro: FiltroConsultaReciboResumen) => ({ type: CONSULTAR_NOVEDADES_RESUMEN_XLS, filtro });
export const exitoConsultaNovedadesResumenXLS = () => ({ type: EXITO_CONSULTA_NOVEDADES_RESUMEN_XLS });
export const errorConsultaNovedadesResumenXLS = () => ({ type: ERROR_CONSULTA_NOVEDADES_RESUMEN_XLS });

export const limpiarMensajesEstado = () => ({ type: LIMPIAR_MENSAJES_ESTADO });


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/recibo_novedades_resumen/modulos/reciboNovedadesResumenActions.ts